import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * URL-param folder navigation for the id-based resource-folder taxonomies
 * (the shared `folders` table): `?canvasFolder` for canvases, `?chatFolder`
 * for chats. Independent of the path-based file `?path` nav, so the three
 * axes coexist across tabs. null = the workspace root of that section.
 */
export function useResourceFolderNavigation(
  param: "canvasFolder" | "chatFolder",
) {
  const [searchParams, setSearchParams] = useSearchParams();
  const currentFolderId = searchParams.get(param) || null;

  const navigate = useCallback(
    (folderId: string | null) => {
      setSearchParams((prev) => {
        const next = new URLSearchParams(prev);
        if (folderId) next.set(param, folderId);
        else next.delete(param);
        return next;
      });
    },
    [param, setSearchParams],
  );

  return { currentFolderId, navigate };
}
